import script from "./live.vue?vue&type=script&setup=true&lang=js"
export * from "./live.vue?vue&type=script&setup=true&lang=js"

import "./live.vue?vue&type=style&index=0&id=9632cdaa&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9632cdaa"]])

export default __exports__